export class NewVM {
    id: string;
    category: CategoryVM[];
    content: string;
    feature: string;
    title: string;
    image: ImageVm[];
    updatedAt: string;
    intro: string;
    publishedAt: string;
    organization: OrganizationVM[];
    publishTime: string;
    referenceURL: string;

    constructor() {
        this.category = [];
        this.content = '';
        this.feature = '';
        this.id = '';
        this.title = '';
        this.image = [];
        this.updatedAt = '';
        this.intro = '';
        this.publishedAt = '';
        this.organization = [];
        this.publishTime = '';
        this.referenceURL = '';
        
    }
}

export class CategoryVM {
    id: string;
    name: string;
    description: string;

    constructor() {
        this.id = '';
        this.name = '';
        this.description = '';
    }
}

export class ImageVm {
    url: string;
    formats: FormatVm;
    
    constructor() {
        this.url = '';
        this.formats = new FormatVm();
    }
}
export class FormatVm {
    large: ImageVm;
    medium: ImageVm;
    small: ImageVm;
    thumbnail: ImageVm;
    
    constructor() {
        this.large = new ImageVm();
        this.medium = new ImageVm();
        this.small = new ImageVm();
        this.thumbnail = new ImageVm();
    }
}

export class OrganizationVM {
    id: string;
    name: string;

    constructor() {
        this.id = '';
        this.name = '';
    }
}